import { render, staticRenderFns } from "./HostDetachBackupStorageDialog.vue?vue&type=template&id=10ac291c&"
import script from "./HostDetachBackupStorageDialog.vue?vue&type=script&lang=js&"
export * from "./HostDetachBackupStorageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports